import { useEffect } from "react";
import { useParams } from "react-router-dom";

// Receipt links in emails point at the site domain, this page forwards to the API that
// serves the PDF — so the link never depends on where the API is hosted.
export default function ReceiptPage() {
  const { token } = useParams();
  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/receipts/${token}`);
  }, [token]);
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background p-6" data-testid="receipt-redirect">
      <p className="text-sm font-bold text-foreground">…</p>
    </div>
  );
}
